import { render, staticRenderFns } from "./LawNormViewStage.vue?vue&type=template&id=04df1fe0"
import script from "./LawNormViewStage.vue?vue&type=script&lang=js"
export * from "./LawNormViewStage.vue?vue&type=script&lang=js"
import style0 from "./LawNormViewStage.vue?vue&type=style&index=0&id=04df1fe0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports